import {
    GET_BILLS_REQUEST, GET_BILLS_SUCCESS, GET_BILLS_FAIL,
    CREATE_BILL_REQUEST, CREATE_BILL_SUCCESS, CREATE_BILL_FAIL,
    UPDATE_BILL_REQUEST, UPDATE_BILL_SUCCESS, UPDATE_BILL_FAIL,
    DELETE_BILL_REQUEST, DELETE_BILL_SUCCESS, DELETE_BILL_FAIL,
    UNDO_BILL_REQUEST, UNDO_BILL_SUCCESS, UNDO_BILL_FAIL,
    GET_PENALTIES_REQUEST, GET_PENALTIES_SUCCESS, GET_PENALTIES_FAIL,
    GET_BILLS_PAGINATION
} from "../types/billTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants';
import cogoToast from "cogo-toast";
import { LOCAL_STORAGE } from "../../config/const";


export const deleteBill = (id) => async (dispatch) => {

    dispatch({ type: DELETE_BILL_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "billReferenceNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: DELETE_BILL_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: DELETE_BILL_FAIL, payload: error.message })
    }
}

export const undoApproveBill = (dataUnapprove) => async (dispatch) => {

    dispatch({ type: UNDO_BILL_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "billDetails": dataUnapprove
        }
        console.log(headerData)
        console.log(dataUnapprove)
        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}purchase/bill/updateBillStatusOnly`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UNDO_BILL_SUCCESS, payload: data });
        window.location.reload()

    } catch (error) {
        if (error?.response?.data?.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        } else {
            console.log(error)
        }
        dispatch({ type: UNDO_BILL_FAIL, payload: error.message })
    }
}


export const updateBill = (updateBillData) => async (dispatch) => {

    dispatch({ type: UPDATE_BILL_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/update`, updateBillData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });
        dispatch({ type: UPDATE_BILL_SUCCESS, payload: data });
        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' });

        } else {

            if (updateBillData.fileUpload) {
                console.log("Filleelele", updateBillData)

                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNo')

                let uploadBillData = {
                    "customerNo": customerNo,
                    "userId": userId,
                    "billReferenceNo": updateBillData.billReferenceNo,
                    "billFile": updateBillData.fileUpload
                }

                Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/uploadBill`, uploadBillData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then((response => {
                    cogoToast.loading("Loading your data...", { position: 'top-right' }).then(() => {
                        if (response.data.status === 0) {
                            cogoToast.error(response.data.message)
                        } else {
                            cogoToast.success(response.data.message)
                            window.location.href = '/bill';
                        }
                    })

                }))
                    .catch(error => {
                        cogoToast.error(error.message, { position: 'top-right' })
                    })
            } else {
                cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                    window.location.href = '/bill';
                })
            }
        }
    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: UPDATE_BILL_FAIL, payload: error.message })
    }
}

export const createBill = (createBillData) => async (dispatch) => {

    dispatch({ type: CREATE_BILL_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/create`, createBillData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: CREATE_BILL_SUCCESS, payload: data });

        if (data.status === 0) {
            cogoToast.error(data.message, { position: 'top-right' });

        } else {

            if (createBillData.fileUpload) {
                console.log("Filleelele", createBillData)

                let token = localStorage.getItem('apiToken')
                let userId = localStorage.getItem('userId')
                let customerNo = localStorage.getItem('customerNo')

                let uploadBillData = {
                    "customerNo": customerNo,
                    "userId": userId,
                    "billReferenceNo": createBillData.billReferenceNo,
                    "billFile": createBillData.fileUpload
                }

                Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/uploadBill`, uploadBillData, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                }).then((response => {
                    cogoToast.loading("Loading your data...", { position: 'top-right' }).then(() => {
                        if (response.data.status === 0) {
                            cogoToast.error(response.data.message)
                        } else {
                            cogoToast.success(response.data.message)
                            window.location.href = '/bill';
                        }
                    })

                }))
                    .catch(error => {
                        if (error.response.data.status === 400) {
                            cogoToast.error(error.response.data.message, { position: 'top-right' })
                        }
                    })
            } else {
                cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                    window.location.href = '/bill';
                })
            }




        }

    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: CREATE_BILL_FAIL, payload: error.message });
    };
};

export const getBills = (billRefNo,billId) => async (dispatch) => {

    dispatch({ type: GET_BILLS_REQUEST });

    try {

        const headerData = (billRefNo,billId) => {
            if (billRefNo && billId ) {
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                    "searchString": billRefNo,
                    "billId":billId
                }
            }
            else if (billRefNo) {
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                    "searchString": billRefNo,
                }
            } else {
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills`, headerData(billRefNo, billId), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });

        dispatch({ type: GET_BILLS_SUCCESS, payload: data });


    } catch (error) {
        if (error?.response?.data?.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};

export const getBillPagination = (page, searchValue, filterData={}) => async (dispatch) => {

    dispatch({ type: GET_BILLS_REQUEST });

    const { userId, customerNo, userToken } = LOCAL_STORAGE;

    try {

        const headerData = () => {
            return {
                "api_token": userToken,
                "customerNo": customerNo,
                "userId": userId,
                ...(searchValue ? {"searchString": searchValue} : {}),
                ...filterData
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills?page=${page}`, headerData(), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": userToken,
                "Access-Control-Allow-Origin": "*",
            }
        });

        dispatch({ type: GET_BILLS_SUCCESS, payload: data });
        dispatch({ type: GET_BILLS_PAGINATION, payload: data.pagination });

    } catch (error) {
        if (error?.response?.data?.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};

export const getFilteredBills = (filteredData) => async (dispatch) => {

    dispatch({ type: GET_BILLS_REQUEST });

    try {


        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills`, filteredData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_BILLS_SUCCESS, payload: data });


    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};


export const getVendorBills = (vendorName, vendorBranchCode, vendorCode, edit) => async (dispatch) => {

    dispatch({ type: GET_BILLS_REQUEST });

    try {

        const headerData = (vendorCode, vendorBranchCode, branchCode, edit) => {
            if (vendorCode, vendorBranchCode, vendorCode && edit) {
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorCode,
                    "vendorBranchCode": vendorBranchCode,
                    "branchCode": branchCode,
                    "billStatus": [2, 4],
                    "completePayment": "0"
                }
            } else {
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                    "vendorCode": vendorCode,
                    "vendorBranchCode": vendorBranchCode,
                    "branchCode": branchCode,
                    "billStatus": [2, 4],
                    "completePayment": "0"
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getBills`, headerData(vendorName, vendorBranchCode, vendorCode, edit), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_BILLS_SUCCESS, payload: data });

    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_BILLS_FAIL, payload: error.message });
    };
};




export const getPenalties = (billData) => async (dispatch) => {

    dispatch({ type: GET_PENALTIES_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/bill/getPenalty`, billData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*",
            }
        });
        dispatch({ type: GET_PENALTIES_SUCCESS, payload: data });


    } catch (error) {
        if (error.response.data.status === 400) {
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_PENALTIES_FAIL, payload: error.message });
    };
};